import React, { useEffect, useState } from "react";
import axios from "axios";
import { formatSalesValue } from "../../utils/formatUtils";

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const TodaysSalesByCompany = ({ banquetUrls }) => {
    const [chartData, setChartData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchData = async () => {
        try {
            if (!banquetUrls?.length) return;

            setLoading(true);
            setError(null);

            const responses = await Promise.all(
                banquetUrls.map((outlet) =>
                    axios.post(
                        `${outlet.url}/todaysOutletSales`,
                        { token: outlet.token }
                    )
                )
            );

            const datasets = responses.map((response, index) => {
                const salesData = response?.data?.data?.[0];

                return {
                    id: banquetUrls[index].id, // keep track via id
                    label:
                        salesData?.Outlet_Name ||
                        `Outlet ${banquetUrls[index].id}`,
                    data: [
                        parseFloat(
                            salesData?.todays_total_sales || 0
                        ),
                    ],
                    backgroundColor: [
                        "#118AB2",
                        "#FF6B6B",
                        "#06D6A0",
                        "#FFD166",
                        "#8E44AD",
                    ][index % 5],
                    borderRadius: 8,
                };
            });

            setChartData({
                labels: ["Today"],
                datasets,
            });
        } catch (err) {
            console.error("Error fetching today's sales:", err);
            setError(
                err.response?.data?.error ||
                err.response?.data?.message ||
                err.message ||
                "Failed to load today's sales data."
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [banquetUrls]);

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: "bottom",
            },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        return `${context.dataset.label}: ${formatSalesValue(
                            context.raw
                        )}`;
                    },
                },
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                title: {
                    display: true,
                    text: "Sales Amount",
                },
            },
        },
    };

    return (
        <div className="bg-white rounded-lg shadow-lg p-3 lg:p-4 w-full">
            <h1 className="text-lg lg:text-xl text-gray-700 font-semibold text-center mb-4">
                Today's Sales By Banquet
            </h1>

            {/* Loading */}
            {loading && (
                <div className="text-center text-blue-600 font-medium">
                    Loading...
                </div>
            )}

            {/* Error */}
            {error && (
                <div className="text-center text-red-600 font-medium">
                    {error}
                </div>
            )}

            {/* Chart */}
            {!loading && !error && chartData && (
                <div className="h-[320px] lg:h-[400px] w-full">
                    <Bar data={chartData} options={options} />
                </div>
            )}
        </div>
    );
};

export default TodaysSalesByCompany;
